/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  // GK-HUB: Parse spreadsheet for advanced campaigns
  parseSpreadsheet(file, phoneColumn, nameColumn) {
    const formData = new FormData();
    formData.append('file', file);
    if (phoneColumn) {
      formData.append('phone_column', phoneColumn);
    }
    if (nameColumn) {
      formData.append('name_column', nameColumn);
    }
    return axios.post(`${this.url}/parse_spreadsheet`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
  // GK-HUB: end parse spreadsheet

  // GK-HUB: ERP segment integration
  getN8nSegments() {
    return axios.get(`${this.url}/n8n_segments`);
  }

  querySegment(segmentId, parameters = {}, customEndpoint = null) {
    const payload = { segment_id: segmentId, parameters };
    if (customEndpoint) {
      payload.custom_endpoint = customEndpoint;
    }
    return axios.post(`${this.url}/query_segment`, payload);
  }
  // GK-HUB: end ERP segment

  // GK-HUB: Campaign dashboard stats
  getStats() {
    return axios.get(`${this.url}/stats`);
  }
  // GK-HUB: end campaign stats

  // GK-HUB: R4 — Dry-run: test send to single phone
  dryRun(campaignId, testPhone) {
    return axios.post(`${this.url}/${campaignId}/dry_run`, {
      test_phone: testPhone,
    });
  }
  // GK-HUB: end R4 endpoints
}

export default new CampaignsAPI();
